export default "__VITE_ASSET__CYt9joG6__"